import { useEffect, useState } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Tab1 from './Tab1';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Box, Breadcrumbs, Chip, Typography, emphasize, styled } from '@mui/material';
import SweetAlert from 'sweetalert2';
import Data from '../../../Data/Data.json';
import { Crypter } from '../../../Functions/Security/Crypter';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import DataProcurationClient from '../../../Types/DataProcurationClient';
import PROCURATION from '../../../Models/Procuration';
import { useNavigate } from 'react-router-dom';
import VerifDay from '../../../Functions/Traitement/VerifDay';
// import {Fab ,Badge} from '@mui/material';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;



const Procuration = () => {

  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  // USER TOKEN
  const authHeader = useAuthHeader()
  const [form] = Form.useForm();
  const [StartSearchG, SeStartSearchG] = useState<boolean>(false);
  const [B_Ajout_Disabled, setB_Ajout_Disabled] = useState(false);
  const [B_Modif_Disabled, setB_Modif_Disabled] = useState(true);
  const [B_Annul_Disabled, setB_Annul_Disabled] = useState(true);
  const [B_Print_Disabled, setB_Print_Disabled] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [dataRCL, SetData] = useState<DataProcurationClient[]>([]);
  const [loading, setLoading] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("");
  const [Load, SetLoad] = useState(false);
  const Navigate=useNavigate();


  useEffect(() => {
    forceUpdate({});
    if(Load===false)
    {
      VerifDay(user.coduti,user.codage,authHeader,Navigate);
      SetLoad(true);
     }
  }, []);

  function initialiazeButton() {
    SeStartSearchG(false)
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    let data = form.getFieldValue("IdClient")?form.getFieldValue("IdClient"):'';
    if(data.length>0){
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    SeStartSearchG(true)
    //form.resetFields()
    form.setFieldValue("niveau", 900)
  }
   else  SweetAlert.fire({ title: "Veuillez Saisir l'identifiant du client", text: "", icon: 'info', confirmButtonText: 'OK' })
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(true)
  }

  function handleAnulle() {
    SetData([]);
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
   // window.location.reload();
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }

  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }

  const StartConsult = () => {
    setB_Ajout_Disabled(true);
    SeStartSearchG(true);
    setB_Modif_Disabled(false);
    //SetFormDisabled(true);
    // setB_Eng_Disabled(true);
    setB_Annul_Disabled(false);
    setB_Print_Disabled(true);

  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Procuration Clients
        </span>
      ),
      children: <Tab1 etatG={StartSearchG} form={form} data={dataRCL} Consult={StartConsult} />,
    }
  ];


  const onFinish = (values: any) => {
    var procuration: PROCURATION = values;
    procuration.utilis = user.coduti;
    procuration.agccpt=user.codage;

    if (sbmit == "add") {
      procuration.datcre=(new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/",'-');
      SweetAlert.fire({
        title: "Enregistrement de la procuration",
        text: "Voulez-vous enregistrer  " + procuration.nom + " " + procuration.prenom + " " + "comme Mandataire " + " " + procuration.lib_filiation + " " + "de" + " " + procuration.lib_IdClient + "?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)
          //let group = profilsDistant.find(()=>)
          console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(procuration)));


          let data = Crypter.encrypt(JSON.stringify(procuration));
          //console.log(data);
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.CreateNewPROCURATION,
            headers: {
              'Accept': '*/*',
              // 'CypherRelation': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data

          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                if (res.StatutCode == 200) {
                  form.resetFields()
                  localStorage.clear()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" }).then((result)=>{
                    if (result.isConfirmed || result.isDenied) {
                      window.location.reload();
                      localStorage.clear()
                      initialiazeButton()
            
                      setSbmit("")
                    }
                  })
                
                }
                else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
            });
        }
      })
    }
    if (sbmit == "update") {
      SweetAlert.fire({
        title: "Modification de la procuration",
        text: "Voulez-vous modifier la procuration " + procuration.Refprocur + " ?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)

          console.log('Received values of form: ', procuration);

          let data = Crypter.encrypt(JSON.stringify(procuration));

          let config = {
            method: 'put',
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            url: Data.ApiUrl.UpdateProcuration,
            headers: {
              // 'Accept': 'application/json',
              // 'CypherRelation': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };


          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data));

                if (res.StatutCode == 200) {
                  let code = procuration.Refprocur
                  form.resetFields()
                  localStorage.clear()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })

                  initialiazeButton()
                  localStorage.setItem(Data.LocalVariable.reset, '1')

                  setSbmit("")
                }
                else {
                  SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });
        }
      })
    }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  function consult() {
    let data = form.getFieldValue("IdClient")?form.getFieldValue("IdClient"):'';
    //let clearNumcli = form.getFieldValue("IdClient");

    SetData([]);
    if (data.length > 0) {
      initialiazeButton()
      setLoading(true);

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetProcuration,
        headers: {
          'CypherNumcli': Crypter.encrypt(data),
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);

          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));
         
            if (res.StatutCode == 200)
             {
              if (res.Result.Table.length > 0) {
                // alert(JSON.stringify(res));
                SetData([]);
                setLoading(true);
                const datat: DataProcurationClient[] = [];
                //
                res.Result.Table.map((data: any, indice: number) => {
                  // console.log(data);
                  datat.push({
                    key: indice,
                    idclient: data.idrel,
                    CODEREL: data.Refprocur,
                    Nom: data.nom,
                    Prenom: data.prenom,
                    Tel: data.TelProcur,
                    ville: data.lieuNais,
                    DateDebut: data.datDebut.substring(0, 10),
                    DateFin: data.DatFin.substring(0, 10),
                    plafond: data.Plafond + "  " + "FCFA",
                    filiation: data.filiation + "-" + data.lib_filiation,
                    Datecre: data.datcre.toString(),
                    RelObject: data
                  });
                })
                SetData(datat);
                
              } else {
                SweetAlert.fire({ title: "Warning", text: "le client ne possede pas aucune relation", icon: "warning" })
              }

              cunsultButton();
              console.log(form.getFieldsValue());
            }
            else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
        });
    }
  }

  function modif() {
    modifButton();
  }

  return (

    <div className='tab'>
      <Box className='formTitle'> <Breadcrumbs aria-label="breadcrumb">
        <StyledBreadcrumb
          component="a"
          href="/jjh"
          label="Home"
          icon={<HomeIcon fontSize="small" />}
        />
        <StyledBreadcrumb component="a" href="#" label="Gestion" />
        <StyledBreadcrumb
          label=" GESTION PROCURATION "
          deleteIcon={<ExpandMoreIcon />}

        />
      </Breadcrumbs></Box>
      <Spin spinning={loading} size='large' tip="En Cour de traitement..." style={{ color: '#116599' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Imprimer
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
            <div>
            </div>
          </div>
        </Form>
        <div>
          <div>
          </div>
        </div>
      </Spin>
    </div>

  );
}
export default Procuration;